import { customer } from '@icabbi/api-gateway-client';
import { Authentication } from '@icabbi/vue-authentication';

const { PaymentOnboardingServiceConnector } = customer;

const defaultState = {
  paymentOnboardingServiceClient: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  paymentOnboardingServiceClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (state.paymentOnboardingServiceClient === null) {
      const authentication = Authentication({ dispatch, getters: rootGetters });
      const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
      const paymentOnboardingServiceClient = new PaymentOnboardingServiceConnector({
        baseURL: process.env.VUE_APP_API_GATEWAY_URL,
        timeout: process.env.VUE_APP_HTTP_REQUEST_TIMEOUT,
      });
      paymentOnboardingServiceClient.httpClient.interceptors
        .response.use(undefined, error => authenticationFailureInterceptor(error));
      paymentOnboardingServiceClient.httpClient.interceptors
        .request.use(config => bearerTokenInterceptor(config));
      state.paymentOnboardingServiceClient = paymentOnboardingServiceClient;
    }
    return state.paymentOnboardingServiceClient;
  },

};

const actions = {
  async init(context, selectedFleetId) {
    try {
      const payload = selectedFleetId ? { fleetId: selectedFleetId } : {};
      const paymentOnboardingServiceClient = context.getters
        .paymentOnboardingServiceClient(context);
      return await paymentOnboardingServiceClient.init(payload);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch('globalMessages/addError',
        { message: 'paymentOnboarding.paymentOnboardingInitError' },
        { root: true });
      return null;
    }
  },
  async validate(context, fleetId) {
    try {
      const payload = fleetId ? { fleetId } : {};
      const paymentOnboardingServiceClient = context.getters
        .paymentOnboardingServiceClient(context);
      await paymentOnboardingServiceClient.validate(payload);
      context.dispatch('globalMessages/addSuccess',
        { message: 'paymentOnboarding.successTitle' },
        { root: true });
      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch('globalMessages/addError',
        { message: 'paymentOnboarding.paymentOnboardingValidateError' },
        { root: true });
      return false;
    }
  },
};
const mutations = {};

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations,
};
